"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : IMAGE UPLOADER : STYLES --------------- ++++++++++ */


var _default = {
  imageuploader: {
    width: 'fit-content',
    height: 'fit-content',
    textAlign: 'center',
    '& .inputbutton': {
      position: 'relative',
      height: (0, _index.pxToEm)(48),
      width: (0, _index.pxToEm)(213)
    },
    '& input': {
      cursor: 'pointer',
      height: '100%',
      width: '100%',
      position: 'absolute',
      left: 0,
      top: 0,
      opacity: 0
    },
    '&.uploading-true': {
      '& .inputbutton': {
        pointerEvents: 'none'
      }
    }
  }
};
exports.default = _default;